<template lang="pug">
  SingleLayout(
    :item='true'
  )
    template(
      slot='item'
    )
      ProfileEditor(
        v-if='person'
        ref='editor'
        :artist='person'
        :albums='personalAlbums'
        :singles='personalSingles'
      )
</template>

<script>
import { mapGetters } from "vuex";

import singlePage from "@/mixins/pages/single.mixin";
import PageLoader from "@/services/pageLoader";
import l10n from "@/services/l10n";
import ProfileEditor from "@/components/Editor/ProfileEditor";
import errorHandler from "@/services/errorHandler";

const strategy = async function(route, ctx) {
  try {
    await PageLoader.getPersonalInfo();

    route.meta.title = l10n("EDITING_PROFILE");
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    const { singles } = await PageLoader.getPersonalSingles();
    const singlesIds = singles.map(album => album.id);

    ctx.personalSinglesIds = singlesIds;
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { albums } = await PageLoader.getPersonalAlbums();
    const albumsIds = albums.map(album => album.id);

    ctx.personalAlbumsIds = albumsIds;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "PersonalPageEdit",
  mixins: [singlePage(strategy)],
  data() {
    return {
      personalSinglesIds: [],
      personalAlbumsIds: []
    };
  },
  computed: {
    ...mapGetters({
      person: "personal/info",
      albums: "albums/albums"
    }),
    personalId() {
      return this.personal.id;
    },
    personalAlbums() {
      return this.personalAlbumsIds.reduce((albums, id) => {
        return this.albums[id] ? [...albums, this.albums[id]] : albums;
      }, []);
    },
    personalSingles() {
      return this.personalSinglesIds.reduce((singles, id) => {
        return this.albums[id] ? [...singles, this.albums[id]] : singles;
      }, []);
    }
  },
  components: {
    ProfileEditor
  },
  async beforeRouteLeave(to, from, next) {
    window.onbeforeunload = null;

    const editor = this.$refs.editor;

    if (await editor.canLeavePage()) {
      return next();
    }

    return next(false);
  }
};
</script>
